import { useEffect } from 'react';

import Reducer from '../modules/reducers/Reducer';
import { ERROR_VALIDATE, STATUS_MESSAGE } from '../lib/Error';
import useError from './useError';
import * as api from '../lib/api/api';

export const usePasswordReset = (code) => {
  const [state, setValue, onChange, setValueAll] = Reducer({
    check: false,
    password: '',
    confirmPassword: '',
    toSignIn: false,
  });

  const { onAlertStatusError } = useError();

  useEffect(() => {
    handleCheckResetCode();
  }, []);

  const handleCheckResetCode = () => {
    api.checkResetCode({ code }).then((response) => {
      setValue({ name: 'check', value: response.data });
    });
  };

  const { password, confirmPassword } = state;

  const onSubmit = () => {
    if (password === confirmPassword) {
      const message = STATUS_MESSAGE.user.changePassword;
      api
        .passwordReset({ code, password })
        .then((response) => {
          alert(message[200]);
          setValue({ name: 'toSignIn', value: true });
        })
        .catch((error) => {
          onAlertStatusError({ message, error });
        });
    } else {
      alert(ERROR_VALIDATE.confirmPassword);
    }
    setValueAll({
      object: {
        password: '',
        confirmPassword: '',
      },
    });
  };

  return { onChange, state, onSubmit };
};
